module.exports = {"content":{},"productInfo":{"code":"{8A880A2E-AA98-4263-B987-18E3B7EFEC28}","name":"ギリシャ語　初中級","serialHead":"ZTAUR","courseResourceIDs":[{"levelNo":1,"resourceID":"06bdc370664f221c2165fc4b974e4cb91684952f"},{"levelNo":2,"resourceID":"53cbb6cc735bdafd11c117720083199817f158d5"},{"levelNo":3,"resourceID":"0eb32fdb9e45d5877a36897f6b859e55bedb9350"}],"language":"el-GR","challengeCount":21693},"version":"1.1.0"}


//////////////////
// WEBPACK FOOTER
// ./static/data.json
// module id = 207
// module chunks = 1